import { keepPreviousData, useQuery } from "@tanstack/react-query";
import React from "react";
import { useParams } from "react-router";
import { useDocApiClient } from "../api/apiClients";
import { InternalError } from "../components/Errors/InternalError";
import Loading from "../components/Loading";
import { defaultConfig } from "../components/Orion/Config/ConfigDefault";
import ConfigForm from "../components/Orion/Config/ConfigForm";
import { ConfigFormProvider } from "../components/Orion/Config/ConfigFormContext";
import { PipelineConfigDb } from "../interfaces/doc";

export function ConfigPage() {
  const { configId } = useParams<{ configId: string }>();
  const apiClient = useDocApiClient<PipelineConfigDb>();
  const isNew = configId === "new";

  const {
    data: configDb,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["config", configId as string],
    queryFn: () => apiClient("GET", `/config/${configId}`),
    placeholderData: keepPreviousData,
    enabled: configId !== "new",
    staleTime: Infinity,
  });

  return (
    <React.Fragment>
      {isError ? (
        <InternalError />
      ) : isLoading ? (
        <Loading />
      ) : (
        <ConfigFormProvider
          isNew={isNew}
          formProps={{
            defaultValues: async () => {
              if (isNew || !configDb) {
                return {
                  config: defaultConfig(),
                  name: `Nouvelle configuration`,
                };
              } else {
                return { config: configDb.config, name: configDb.name };
              }
            },
          }}
        >
          <ConfigForm configDb={configDb} />
        </ConfigFormProvider>
      )}
    </React.Fragment>
  );
}
